export default __webpack_public_path__ + "static/cloudator-responsive-landing-home-4527d1a29754b7db67a1753317d6dc3e.jpg";